(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["zc-live-hero"] && !Shopify.designMode) return;
  try {
    
function zcInitHero(scope){
  (scope||document).querySelectorAll('[data-zc-slider]').forEach(root=>{
    if(root.dataset.zcInitialized==='true')return;
    root.dataset.zcInitialized='true';
    const slides=[...root.querySelectorAll('[data-zc-slide]')];
    const buttons=[...root.querySelectorAll('[data-zc-slide-button]')];
    if(slides.length<2)return;
    let active=0;let timer;
    const select=(i)=>{
      active=(i+slides.length)%slides.length;
      slides.forEach((slide,j)=>{const is=j===active;slide.classList.toggle('is-active',is);slide.setAttribute('aria-hidden',String(!is));slide.querySelectorAll('a').forEach(a=>a.tabIndex=is?0:-1)});
      buttons.forEach((button,j)=>{button.classList.toggle('is-active',j===active);button.setAttribute('aria-current',String(j===active))});
    };
    const stop=()=>{if(timer)clearInterval(timer)};
    const start=()=>{stop();if(!window.matchMedia('(prefers-reduced-motion: reduce)').matches)timer=setInterval(()=>select(active+1),5000)};
    buttons.forEach((button,i)=>button.addEventListener('click',()=>{select(i);start()}));
    root.addEventListener('mouseenter',stop);root.addEventListener('mouseleave',start);
    root.addEventListener('focusin',stop);root.addEventListener('focusout',e=>{if(!root.contains(e.relatedTarget))start()});
    document.addEventListener('visibilitychange',()=>{if(document.hidden)stop();else start()});
    select(0);start();
  });
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>zcInitHero(document));else zcInitHero(document);
document.addEventListener('shopify:section:load',e=>zcInitHero(e.target));

  } catch(e) { console.error(e); }
})();
})();
